import Link from "./Link";
const Util = {
    Link
}

export default Util